export default __webpack_public_path__ + "static/media/item_ex_3.97dba060.png";